import React, { useEffect, useState, useContext } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import helpers from '../../../services/helpers';
import Loader from '../../parts/Loader';
import { getApiData } from '../../../services/apiService';
import ProductUnitInputs from './ProductUnitInputs';
import { productUnitData } from '../../../services/serviceHubStore';
import Swal from 'sweetalert2';
import { postApiData } from '../../../services/apiService';
import ProfileContext from '../../../services/profileContext';
 
export default function ProductUnitFormModal ({
    is_show = false, 
    setShow, 
    handleSelect, 
    ref_id,
    handleSave,
    customer_id,
}){
    const {
        account
    } = useContext(ProfileContext);

    const [errors, setErrors] = useState([]);
    const [modal_title, setModalTitle] = useState('New Product Unit Detail');
    const [reload, setReload] = useState(0);
    const [form_data, setFormData] = useState(productUnitData);
    const [loading, setLoading] = useState(1);
    const [notice, setNotice] = useState('');
   
    useEffect(() => {

    }, []);
   
    useEffect(() => {
        if(is_show) {
            setNotice()
            setErrors()

            if(ref_id){
                setModalTitle('Edit Product Unit Detail')
                setLoading(1)
                fetchData(ref_id)
            }
            else{
                setModalTitle('New Product Unit Detail')
                setFormData(productUnitData)
                fetchCustomer(customer_id)
            }
        }
    }, [is_show]);

    async function fetchData(product_unit_id){
        if(!product_unit_id){
            return
        }
        const url = helpers.createUrl('V1/manage/invoices/'+product_unit_id+'?store_id='+helpers.getStoreID())

        let endpoint = helpers.createServiceHubUrl(`v1/product-details/${product_unit_id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            res.purchased_date = res.purchased_date ? new Date(res.purchased_date) : ''
            res.polarcare_start_date = res.polarcare_start_date ? new Date(res.polarcare_start_date) : ''
            setFormData(res)
            setLoading(0)
            //fetchEnums()
        }
        
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/product-units/list");
                }
            })
        }
    }

    async function fetchCustomer(customer_id){
        if(!customer_id){
            return
        }

        //`?store_id=${helpers.getStoreID()}&`

        let endpoint = helpers.createUrl(`V1/manage/contact/${customer_id}?store_id=${account?.default_store_id}`)
        const res = await getApiData(endpoint, true)

        if(res){
            setFormData(prev => ({
                ...prev,
                customer_id: res.id,
                customer_name: res.contact_name,
            }));
            setLoading(0)
        }
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function onSelect(e){
        reset();
        setShow(0);
        handleSelect(e)
    }

    function reset(){
        setNotice('')
    }

    async function submitForm(e) {
        let endpoint = helpers.createServiceHubUrl(`v1/product-details/create`)
        if(ref_id){
            endpoint = helpers.createServiceHubUrl(`v1/product-details/${ref_id}`)
        }
        const res = await postApiData(endpoint, form_data)

        setLoading(0)
        if(res.error_code){
            if(res.data){
                setReload(Math.random());
                setErrors( res.data );
            }else{
                setErrors([])
            }
            return
        }

        let id = ref_id;
        let data = {...form_data}
        if(!id){
            data.id = res.data.id
        }

        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
        })
        .then((result) => {
            handleSave(data)
            setShow(0)
        })
    }

    return (
        <>
            <Modal show={is_show} size="xl">
                <Modal.Header>
                    <h5>{modal_title}</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <ProductUnitInputs 
                        key={reload}
                        ref_id={ref_id} 
                        setLoading={setLoading}
                        setFormData={setFormData}
                        form_data={form_data}
                        errors={errors}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <small>Note: Clicking "Save" will directly update the records under Product Unit Detail.</small>
                    <button type='button' className='btn btn-success ml-3 ' onClick={(e) => submitForm(1)} disabled={loading}><i className="fas fa-check mr-2" />Save</button>  
                </Modal.Footer>
            </Modal>
        </>
    )
}